app.controller('analysisController', function ($rootScope, $scope, $sce, $filter, $http, $window, $routeParams, $location, safeApply, cookieService, apiService, subjectMapService) {

  mapboxgl.accessToken = apiService.getMapboxAccessToken()

  const mapboxClient = mapboxSdk({ accessToken: 'pk.eyJ1IjoiZ2xlbm5nIiwiYSI6ImNpZmZ1ZnZqbjh5eGJzdWtua3Zib3M0c2gifQ.TcurCtii8i7e3w7oo1WW5Q' })
  const returnURL = `https://dashboard.propertytax.io/${$routeParams.user_id}/${$routeParams.token}`
  const routeURL = `/${$routeParams.cad_code}/${$routeParams.appeal_id}/${$routeParams.user_id}/${$routeParams.token}/`

  let img

  $rootScope.close_only = ($routeParams.close_only === '1' ? true : false)

  $scope.cog_loader_title = "Loading Your Analysis..."
  $scope.analysis = null
  $scope.initializing = true
  $scope.subject_map_url = null

  $scope.changeRoute = function (analysis) {
    $location.path(routeURL + analysis)
  }

  $scope.returnToDashboard = function () {
    $window.location.href = returnURL
  }

  let cad_code,
    parcel_id,
    geo_location,
    map_size

  initController()
  async function initController() {
    // if (apiService.analysisLoaded() == false) {
    let analysis = await apiService.getAnalysis({ appeal_id: $routeParams.appeal_id, cad_code: $routeParams.cad_code })
    console.log('analysis.data :>> ', analysis.data);
    if (analysis.data.success == true) {
      $scope.analysis = analysis.data.data.analysis
      $scope.mini_analysis = analysis.data.data.mini_analysis
      apiService.storeAnalysis(analysis.data.data)
    } else {
      $scope.analysis = null
    }
    // } else { 
    // $scope.analysis = await apiService.loadAnalysis()
    // }

    let fee = $scope.mini_analysis.potential_tax_savings * ($scope.mini_analysis.fee.rate / 100)
    $scope.mini_analysis.fee.amount = (fee > $scope.mini_analysis.fee.cap ? ($scope.mini_analysis.fee.cap * -1) : (fee * -1))
    $scope.mini_analysis.fee.net_savings = $scope.mini_analysis.potential_tax_savings + $scope.mini_analysis.fee.amount

    if ($scope.mini_analysis.fee.rate == 35) {
      $scope.mini_analysis.cap_fee_message = `        
      <p style="line-height: 1.3;">The success fee is a percentage of the tax savings we are able to achieve for you.</p>
      <p style="line-height: 1.3;">The success fee is capped at $${$scope.mini_analysis.fee.cap} for this property, which means that even if 35% of the tax savings is more than the capped fee of $${$scope.mini_analysis.fee.cap}, we only charge $${$scope.mini_analysis.fee.cap}.</p>`
    } else {
      $scope.mini_analysis.cap_fee_message = `
      <p style="line-height: 1.3;">The success fee is a percentage of the tax savings we are able to achieve for you.</p>
      <p style="line-height: 1.3;">Since this property is valued at over $1,000,000, our fee for this property is 40% of the tax savings.</p>`
    }


    $scope.initializing = false

    // console.log('$scope.analysis :>> ', JSON.stringify($scope.analysis.subj, null, 2));
    // console.log('$scope.analysis :>> ', JSON.stringify($scope.analysis, null, 2));

    // PROD WARNING: This is a hack to set the scenario to 1 for the demo
    // Use this to set the scenario
    // $scope.analysis.potential_tax_savings_scenario = 0
    // $scope.mini_analysis.already_signed_up         = false


    $scope.analysis.stats = { comps: 0, helps: 0, hurts: 0, neutral: 0 }
    const stats = $scope.analysis.recentSales.comps.map(item => {
      $scope.analysis.stats.comps++
      if (item.hasOwnProperty('adjusted_close_price')) {
        if (item.supports_reduction && item.credible == 1) {
          item.status = 'helps'
          $scope.analysis.stats.helps++
        } else if (!item.supports_reduction && item.credible == 1) {
          item.status = 'hurts'
          $scope.analysis.stats.hurts++
        } else {
          item.status = 'neutral'
          $scope.analysis.stats.neutral++
        }
      }
    })
    console.log('$scope.analysis.stats :>> ', $scope.analysis.stats);

    await updateStaticMapURL($scope.analysis.subj.cad_code, $scope.analysis.subj.cad_account, $scope.analysis.subj.geo_location, { width: 600, height: 450 })

    // $scope.subject_map_url = await subjectMapService.getSubjectMapURL({ lng: $scope.analysis.subj.geo_location.lng, lat: $scope.analysis.subj.geo_location.lat })

    safeApply($scope)
    $(".preloader").fadeOut(200, 'swing')
  }

  function updateStaticMapURL(cad_code, parcel_id, geo_location, map_size) {
    return new Promise((resolve, reject) => {
      const parcelIds = [parcel_id]
      const request = mapboxClient.static.getStaticImage({
        ownerId: 'mapbox',
        styleId: 'satellite-streets-v11',
        width: map_size.width,
        height: map_size.height,
        position: {
          coordinates: [geo_location.lng, geo_location.lat],
          zoom: 18
        },
        addlayer: {
          id: 'subject',
          type: 'line',
          source: {
            type: 'vector',
            url: 'mapbox://glenng.a1g4zj1h'
          },
          'source-layer': `c_${cad_code}_parcels`,
          filter: ['in', ['get', 'parcel_id'], ['literal', parcelIds]],
          paint: {
            "line-color": '#89FA87',
            "line-width": 1
          }
        },
        attribution: false,
        logo: false
      })
      const staticImageUrl = request.url()
      document.getElementById('static_map').src = staticImageUrl
      resolve(staticImageUrl)
    })
  }
})
// End:  AnalysisController
